export const AUTH_ERRORS = {
  fillAllFields: "auth.errors.fill-all-fields",
  invalidEmail: "auth.errors.invalid-email",
  invalidPassword: "auth.errors.invalid-password",
  passwordsNotMatch: "auth.errors.passwords-not-match",
};
